"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterInput = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const cmdk_1 = require("cmdk");
const constants_1 = require("../../../constants");
exports.FilterInput = (0, styled_1.default)(cmdk_1.Command.Input)({
    background: 'none',
    border: 'none',
    font: 'inherit',
    fontSize: 14,
    fontWeight: constants_1.theme.font.weight.legacy[500],
    outline: 'none',
    padding: `${constants_1.theme.padding.button.medium.y}px ${constants_1.theme.padding.button.small.x}px`,
    width: '100%',
});
